import { cityServices } from '@/services'
import { store } from '@/store'
import { forceSearchParamsLoader } from '../utils'
import { officeApi } from '@/store/services'

export const OfficeListLoader = (args) => {
  const initial = {
    page: 1,
    per_page: 7
  }

  return forceSearchParamsLoader({ initial, args }, (searchParams) =>
    store.dispatch(
      officeApi.endpoints.getOffices.initiate(`?${searchParams}`)
    ).unwrap())
}

export const OfficeCreateLoader = (_args) => Promise.all([cityServices.index({ q: '' })])

export const OfficeEditLoader = ({ params: { id } }) => Promise.all([

  cityServices.index({ q: '' }),
  store
    .dispatch(officeApi.endpoints.getOffice.initiate(id))
    .unwrap()
])
